import React from 'react';
import UIRegions from 'shared/constants/UIRegions';
import Modal from 'shared/components/misc/modal.jsx';
import TeleprompterWelcome from 'shared/components/misc/teleprompterWelcome';

/**
 * Global Elements Welcome  Modal
 */
export default React.createClass({
  displayName: 'TeleprompterWelcomeModal',

  propTypes: {
    display: React.PropTypes.bool,
    onHide: React.PropTypes.func,
  },

  render() {
    const { display, onHide } = this.props;

    return (
      <Modal
        display={display}
        className="modal-generic-wrapper teleprompter-welcome-modal"
        headerClassName="modal-generic-header"
        name={UIRegions.TeleprompterWelcomeModal}
        overrideHide
        onHide={onHide}
      >
        <TeleprompterWelcome onHide={onHide} />
      </Modal>
    );
  },
});
